import React, { useEffect, useState, forwardRef, useCallback } from "react";
import AutocompleteField from "../../components/AutocompleteField";
import { isEmpty, axios } from "../../common";

const _ = forwardRef(({ onChange, value }, ref) => {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    try {
      const { status, data } = await axios.get("/certify/station-all");

      if (status === 200) {
        setItems(
          data.data.map((item) => ({
            title: `${item.stationName}(${item.stationNo})`,
            ...item,
          }))
        );
      }
    } catch (e) {}
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    !isEmpty(items) && (
      <AutocompleteField
        value={value}
        optionValues={items}
        placeholder="발전소를 선택하세요."
        onChange={(_, newValue) => {
          onChange(newValue);
        }}
        ref={ref}
      />
    )
  );
});

export default _;
